<template>
  <!--半成品管理-->
  <div>
    <s-pageheader title="半成品管理" />
    <ak-model-filter-card model="parts" @search="search" @reset="reset" :perPage="30" />
    <!--半成品-->
    <ak-model-tree
      :treeSpan="4"
      model="parts"
      treeModel="partWorkShop"
      parentKey="parentNode"
      pointerToTree="model"
      treeTitle="车间检索"
      :defaultSelected="key"
      :multiple="false"
      @selected="getTree"
      :action="edit"
      :modelTableProps="modelTableProps"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
import editParts from '@/core/components/editParts'
import { mapState } from 'vuex'
import store from '@/store'
export default {
  components: {
    's-pageheader': PageHeader
  },
  data () {
    return {
      edit: { // 覆盖model的action
        create: false
      },
      modelTableProps: {
        perPage: 30
      },
      key: '' // 默认选中的节点ID
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  created () {
    let key = store.state.partsKey
    if (key !== '') {
      if (key.model) {
        if (key.proportion) {
          this.key = key.proportion
        } else {
          this.key = key.model
        }
      } else {
        this.key = key.workShop
      }
    }
  },
  methods: {
    search (filters) {
      this.$set(this.modelTableProps, 'filters', filters)
      this.$set(this.modelTableProps, 'page', 1)
    },
    reset () {
      this.$set(this.modelTableProps, 'filters', {})
      this.$set(this.modelTableProps, 'page', 1)
    },
    // 监听树节点选中状态
    getTree (obj) {
      let data = { workShop: '', model: '', proportion: '' }
      if (obj.length > 0 && obj[0] !== undefined) {
        if (obj[0].parentNode) {
          if (obj[0].parentNode.parentNode) {
            data.workShop = obj[0].parentNode.parentNode.key
            data.model = obj[0].parentNode.key
            data.proportion = obj[0].key
          } else {
            data.workShop = obj[0].parentNode.key
            data.model = obj[0].key
          }
        } else {
          data.workShop = obj[0].key
        }
        store.commit('setPartsKey', data)
      } else {
        store.commit('setPartsKey', '')
      }
      // 根据选中的节点判断新建按钮是否显示
      if (obj.length === 1 && obj[0].record.type === 'model' && store.state.user && store.state.user.authority.parts.create) {
        this.edit.create = {
          text: '新建',
          title: '添加半成品',
          modelId: obj[0].key,
          workShop: obj[0].parentNode.key,
          component: editParts
        }
      } else {
        this.edit.create = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .node-icon:before {
    content: none !important;
  }
</style>
